import React, { memo } from 'react';

import classNames from 'classnames';

import cls from './ContractorRow.module.css';
import { useContractorRow } from './useContractorRow';
import { Select } from '../../../../../../../components/newUI/Select/Select';
import { NotGivenRow } from '../../../UI/NotGivenRow/NotGivenRow';

interface ContractorRowProps {
    classes?: string;
}

export const ContractorRow = memo(({ classes }: ContractorRowProps) => {
    const { optionsList, selected, onSelected, is_customer, can_show_financial_info } =
        useContractorRow();

    return (
        <div className={classNames(cls.ContractorRow, [classes])}>
            <span className={cls.title}>{i18next.t('ContractorRow.return.title')}</span>
            {is_customer || !can_show_financial_info ? (
                selected.title ? (
                    <span>{selected.title}</span>
                ) : (
                    <NotGivenRow />
                )
            ) : (
                <div className={cls.contractorList}>
                    <Select
                        title=""
                        options={optionsList}
                        selected={selected}
                        onChange={onSelected}
                        notAbsolute
                        widthClasses={cls.optionWidth}
                        classes={classNames(cls.select, cls.shrinkGrid)}
                        colorClasses={cls.ellipsisSpan}
                    />
                </div>
            )}
        </div>
    );
});
